import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { RevisionEntry } from './revisionModel';
import { revisionMessages } from './revisionMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Revisions.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface RevisionGoneBoxProps {
  entry: RevisionEntry;
}

/** The stage of an old revision whose file is gone (design d4): the row stays, the settings too. */
const RevisionGoneBoxComponent: React.FC<RevisionGoneBoxProps> = ({ entry }) => {
  const intl = useIntl();
  return (
    <div className={styles.goneBox} data-testid="revision-gone">
      <span>
        {intl.formatMessage(revisionMessages.fileRemoved)}{' '}
        {intl.formatMessage(revisionMessages.fileRemovedSettings, { number: entry.number })}
      </span>
    </div>
  );
};

export const RevisionGoneBox = TypedMemo(RevisionGoneBoxComponent);
